module.exports = __webpack_public_path__ + "img/NBowman64_ua.db31b3fb.webp";